import { RiCheckboxBlankLine, RiCheckboxLine } from "react-icons/ri";
import { Col } from "react-bootstrap";
import {  goals } from "../../content_option";

export const Goals = () => {
    return (
        <>
            <Col lg={{ span: 4, offset: 1 }}>
                <h3 className="color_sec py-4 ">Goals</h3>
            </Col>
            <Col lg="7">
                {goals.map((data, i) => {
                    return (
                        <div className="service_ py-4" key={i}>
                            <h5 className="service__title">{data.title}</h5>
                            <p className="service_desc text-justify">{data.description}</p>
                            <p>Therefore, I planned to</p>
                            {
                                data.wishlist.map((wish, index) => {
                                    return <p key={index}>{!wish.status ? <RiCheckboxBlankLine /> : <RiCheckboxLine />}   {wish.title}</p>
                                })
                            }
                        </div>
                    );
                })}
            </Col>
        </>
    )
}